import _extends from 'babel-runtime/helpers/extends';
import _Math$trunc from 'babel-runtime/core-js/math/trunc';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import { getAudioContext } from './AudioContextSingleton';
import { makeCancelablePromise } from './promise-utils';

/** getFloatTimeDomainData polyfill for Safari browser
 *
 *  This does not completely reflect original getFloatTimeDomainData behavior because
 *  getByteTimeDomainData only returns data clamped to range -1...1 but it works fine for our case
 */
if (AnalyserNode && !AnalyserNode.prototype.getFloatTimeDomainData) {
  AnalyserNode.prototype.getFloatTimeDomainData = function (array) {
    var uint8 = new Uint8Array(array.length);
    this.getByteTimeDomainData(uint8);
    uint8.forEach(function (v, i) {
      return array[i] = (v - 128) * 0.0078125;
    });
  };
}

/**
 * withMicrophoneMeter
 * adds a "soundLevel" prop which represents the microphone volume level as a float from 0 to 1
 */
export var withMicrophoneMeter = function withMicrophoneMeter(WrappedComponent) {
  var MicrophoneMeter = function (_PureComponent) {
    _inherits(MicrophoneMeter, _PureComponent);

    function MicrophoneMeter(props) {
      _classCallCheck(this, MicrophoneMeter);

      var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

      _this.startMetering = function () {
        var soundWatchInterval = 100;
        _this.watcherId = setInterval(_this.updateMeterLevel, soundWatchInterval);
      };

      _this.stopMetering = function () {
        if (_this.watcherId) {
          clearInterval(_this.watcherId);
          _this.watcherId = null;
        }
      };

      _this.updateMeterLevel = function () {
        _this.audioAnalyzer.getFloatTimeDomainData(_this.audioDataArray);
        var volumeMax = 0;
        _this.audioDataArray.forEach(function (sample) {
          var absSample = Math.abs(sample);
          volumeMax = Math.max(volumeMax, absSample);
        });
        volumeMax = _Math$trunc(volumeMax * 100) / 100;
        _this.setState({ soundLevel: volumeMax });
      };

      _this.audioAnalyzer = null;
      _this.watcherId = null;
      _this.audioWindowSize = 2048;
      _this.audioDataArray = new Float32Array(_this.audioWindowSize);
      _this.state = {
        soundLevel: 0
      };
      return _this;
    }

    MicrophoneMeter.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      var userMediaPromise = navigator.mediaDevices.getUserMedia({ audio: true });
      this.userMediaCancelablePromise = makeCancelablePromise(userMediaPromise);
      this.userMediaCancelablePromise.promise.then(function (stream) {
        var audioSource = getAudioContext().createMediaStreamSource(stream);
        _this2.audioAnalyzer = getAudioContext().createAnalyser();
        _this2.audioAnalyzer.fftSize = _this2.audioWindowSize;
        audioSource.connect(_this2.audioAnalyzer);
        _this2.startMetering();
      }).catch(function (err) {
        console.log(err);
      });
    };

    MicrophoneMeter.prototype.componentWillUnmount = function componentWillUnmount() {
      if (!this.audioAnalyzer) {
        this.userMediaCancelablePromise.cancel();
      } else {
        this.stopMetering();
      }
    };

    MicrophoneMeter.prototype.render = function render() {
      return React.createElement(WrappedComponent, _extends({ soundLevel: this.state.soundLevel }, this.props));
    };

    return MicrophoneMeter;
  }(PureComponent);

  return MicrophoneMeter;
};